module.exports = __webpack_public_path__ + "static/media/Huawei P8 Black.c38357b3.png";